// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { itemReplacementsStyles } from "@guestsupply/App/Components/ProductDetails/ItemReplacements";
import MenuBack from "@guestsupply/XDL/Icons/MenuBack";
import { createLinkIconStyles, ellipsis } from "@guestsupply/XDL/Utilities";
import { css } from "styled-components";

itemReplacementsStyles.availableOptionsLink = {
    ...createLinkIconStyles(MenuBack, {
        typographyProps: {
            size: 12,
        },
        icon: {
            iconProps: {
                size: 12,
                css: css`
                    opacity: 1;
                `,
            },
            position: "right",
        },
    }),
};
